var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "process-records-dialog",
      attrs: {
        title: _vm.documentConfigName,
        visible: _vm.visible,
        "close-on-click-modal": false,
        "append-to-body": "",
        "before-close": _vm.cancel,
        width: "1000px"
      }
    },
    [
      _c("div", { staticClass: "row", staticStyle: { height: "690px" } }, [
        _c("div", { staticClass: "column", staticStyle: { width: "72%" } }, [
          _c("div", { staticClass: "upper" }, [
            _c(
              "div",
              { staticStyle: { "margin-top": "10px" } },
              [
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c(
                        "h2",
                        {
                          staticStyle: {
                            "margin-left": "30px",
                            color: "#1e74d5"
                          }
                        },
                        [_vm._v(_vm._s(_vm.processTitle))]
                      )
                    ]),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              }
                            ],
                            attrs: { type: "danger" },
                            on: { click: _vm.toTerminateTheProcess }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_TerminateTheProcess")
                              )
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            {
              staticClass: "lower",
              staticStyle: {
                "border-right": "1px solid #E3E3E3",
                overflow: "auto"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "card-container",
                  staticStyle: { "margin-top": "10px" }
                },
                _vm._l(_vm.processNodes, function(nodes, index) {
                  return _c("div", { key: index }, [
                    _c(
                      "div",
                      {
                        key: index,
                        staticClass: "tab-guide-wrapper",
                        class: { flexend: !nodes.isOdd },
                        staticStyle: { display: "flex" }
                      },
                      _vm._l(nodes.data, function(processNode, nodeIndex) {
                        return _c(
                          "div",
                          {
                            key: nodeIndex,
                            style:
                              (nodes.isOdd && nodeIndex === 2) ||
                              (!nodes.isOdd && nodeIndex === 0)
                                ? "display: grid"
                                : "display: flex"
                          },
                          [
                            !nodes.isOdd && nodeIndex > 0
                              ? _c(
                                  "div",
                                  { staticStyle: { "margin-top": "30%" } },
                                  [
                                    !nodes.isOdd && nodeIndex !== 0
                                      ? _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "my-arrow" },
                                            [_vm._v("←")]
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              { class: "record-card " + processNode.color },
                              [
                                _c("div", { staticStyle: { margin: "2px" } }, [
                                  _c("h2", [
                                    _vm._v(_vm._s(processNode.node.name))
                                  ])
                                ]),
                                processNode.showContentList &&
                                processNode.showContentList.length === 1
                                  ? _c("div", { staticClass: "one-center" }, [
                                      _c(
                                        "span",
                                        { staticClass: "one-person" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              processNode.showContentList[0]
                                            )
                                          )
                                        ]
                                      )
                                    ])
                                  : _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            margin: "10px",
                                            "line-height": "21px"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-row",
                                            _vm._l(
                                              processNode.showContentList,
                                              function(contentText, userIndex) {
                                                return _c(
                                                  "el-col",
                                                  {
                                                    key: userIndex,
                                                    attrs: { span: 12 }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "more-person"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              contentText
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ])
                              ]
                            ),
                            (nodes.isOdd &&
                              nodeIndex < nodes.data.length - 1) ||
                            (!nodes.isOdd && nodeIndex > 0)
                              ? _c(
                                  "div",
                                  { staticStyle: { "margin-top": "30%" } },
                                  [
                                    nodes.isOdd
                                      ? _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "my-arrow" },
                                            [_vm._v("→")]
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            ((nodes.isOdd && nodeIndex === 2) ||
                              (!nodes.isOdd && nodeIndex === 0)) &&
                            index !== _vm.processNodes.length - 1
                              ? _c(
                                  "div",
                                  { staticStyle: { "margin-left": "50%" } },
                                  [
                                    _c("div", [
                                      _c("span", { staticClass: "my-arrow" }, [
                                        _vm._v("↓")
                                      ])
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    )
                  ])
                }),
                0
              )
            ]
          )
        ]),
        _c(
          "div",
          {
            staticClass: "app-main-content column",
            staticStyle: { width: "28%", "border-left": "1px solid #E3E3E3" }
          },
          [
            _c(
              "div",
              { staticClass: "tabs-container section" },
              [
                _c(
                  "el-tabs",
                  {
                    staticStyle: { width: "100%" },
                    model: {
                      value: _vm.activeTab,
                      callback: function($$v) {
                        _vm.activeTab = $$v
                      },
                      expression: "activeTab"
                    }
                  },
                  [
                    _c(
                      "el-tab-pane",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_ApprovalRecord"),
                          name: "record"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { "overflow-y": "auto" } },
                          _vm._l(_vm.records, function(card, index) {
                            return _c(
                              "div",
                              { key: index },
                              [
                                _c("el-card", { staticClass: "box-card" }, [
                                  _c("div", [
                                    _c("div", [
                                      _c("h2", [
                                        _vm._v(_vm._s(card.processNode.name))
                                      ])
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        class: _vm.colorStyle(card.actionType),
                                        staticStyle: {
                                          "margin-top": "12px",
                                          "margin-bottom": "12px"
                                        },
                                        attrs: {
                                          title: _vm.recordContentTitle(card)
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.recordContentLabel(card)
                                            ) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "margin-bottom": "12px"
                                        },
                                        attrs: { title: _vm.copyLabel(card) }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.copyLabel(card, 3)) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { "margin-bottom": "12px" }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.getRemark(card.remark)) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c("div", [
                                      _vm._v(
                                        " " + _vm._s(card.createTime) + " "
                                      )
                                    ]),
                                    card.files && card.files.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-top": "10px",
                                              cursor: "pointer"
                                            }
                                          },
                                          _vm._l(card.files, function(
                                            file,
                                            index
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticClass: "file-style"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      margin: "2px",
                                                      display: "flex"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.downloadFile(
                                                          file.fileId
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-paperclip",
                                                      staticStyle: {
                                                        color: "#1e74d5"
                                                      }
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "file-name"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(file.fileName)
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "darkgray"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.WorkflowUtil.fileSizeLabel(
                                                              file.fileSize
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                      : _vm._e()
                                  ])
                                ]),
                                index < _vm.records.length - 1
                                  ? _c("div", [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "margin-left": "50%" }
                                        },
                                        [_vm._v("|")]
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }